import { render, staticRenderFns } from "./MaterialPropertyEdit.vue?vue&type=template&id=9889dcb0&scoped=true"
import script from "./MaterialPropertyEdit.vue?vue&type=script&lang=js"
export * from "./MaterialPropertyEdit.vue?vue&type=script&lang=js"
import style0 from "./MaterialPropertyEdit.vue?vue&type=style&index=0&id=9889dcb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9889dcb0",
  null
  
)

export default component.exports